import { useAddLmsNewsMutation, useUpdateLmsNewsMutation, useDeleteLmsNewsMutation, useUploadLmsNewsPhotoMutation, useDeleteLmsNewsPhotoMutation } from '../../../../api';
import { NEWS_TYPE } from '../utils/newsUtils';

const extractNewsId = (result) => [result?.data, result?.data?.id, result?.id, result].find((value) => typeof value === 'number' && value > 0) ?? null;

// Haber kaydı ve fotoğraf ayrı uçlar; kayıt başarılıysa fotoğraf hatası kaydı geri almaz (doc §2.4).
const useLmsNewsSave = () => {
    const [addNews, { isLoading: isAdding }] = useAddLmsNewsMutation();
    const [updateNews, { isLoading: isUpdating }] = useUpdateLmsNewsMutation();
    const [deleteNews, { isLoading: isDeleting }] = useDeleteLmsNewsMutation();
    const [uploadPhoto, { isLoading: isUploading }] = useUploadLmsNewsPhotoMutation();
    const [deletePhoto, { isLoading: isDeletingPhoto }] = useDeleteLmsNewsPhotoMutation();

    const syncPhoto = async (newsId, photo) => {
        try {
            if (photo?.file) await uploadPhoto({ newsId, file: photo.file }).unwrap();
            else if (photo?.removed) await deletePhoto(newsId).unwrap();
            return true;
        } catch {
            return false;
        }
    };

    /**
     * @returns {Promise<{ newsId: number, photoFailed: boolean }>} kayıt hatasında throw eder.
     */
    const saveNews = async ({ id, fields, photo }) => {
        let newsId = id;
        if (newsId) {
            await updateNews({ id: newsId, ...fields }).unwrap();
        } else {
            const result = await addNews(fields).unwrap();
            newsId = extractNewsId(result);
            if (!newsId) throw new Error('News id missing');
        }
        const photoOk = await syncPhoto(newsId, photo);
        return { newsId, photoFailed: !photoOk };
    };

    const removeNews = (id) => deleteNews(id).unwrap();

    /**
     * Eğitim Planlama "Haberlerde yayınlansın mı?" akışı (doc §2.5).
     * @returns {Promise<{ newsFailed: boolean, photoFailed: boolean }>}
     */
    const syncPlanningNews = async (planningId, request) => {
        if (!request || !planningId) return { newsFailed: false, photoFailed: false };
        const publish = Number(request.publish) === 1;
        try {
            if (!publish) {
                if (request.newsId) await removeNews(request.newsId);
                return { newsFailed: false, photoFailed: false };
            }
            const fields = { shortDescription: (request.shortDescription || '').trim(), detailDescription: (request.detailDescription || '').trim() };
            const { photoFailed } = await saveNews({
                id: request.newsId,
                fields: request.newsId ? fields : { newsType: NEWS_TYPE.TRAINING, planningId, ...fields },
                photo: request.photo
            });
            return { newsFailed: false, photoFailed };
        } catch {
            return { newsFailed: true, photoFailed: false };
        }
    };

    return {
        saveNews,
        removeNews,
        syncPlanningNews,
        isSavingNews: isAdding || isUpdating || isDeleting || isUploading || isDeletingPhoto
    };
};

export default useLmsNewsSave;
